import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function Completion(props) {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return <h1>Thank you! 🎉</h1>;
}

export default Completion;
